import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
var Countdown = /*#__PURE__*/function (_Vue) {
  function Countdown() {
    var _this;
    _classCallCheck(this, Countdown);
    _this = _callSuper(this, Countdown, arguments);
    _this.timeDiff = 0; // 倒计时
    _this.timer = null; // 时间函数
    return _this;
  }
  // 步长转换为毫秒
  _inherits(Countdown, _Vue);
  return _createClass(Countdown, [{
    key: "computedStep",
    get: function get() {
      return this.step * 1000;
    }
    // 监听倒计时时间差变化
  }, {
    key: "onTimeChange",
    value: function onTimeChange(val) {
      this.timeDiff = val;
      var isSwitch = typeof this.switch === 'boolean';
      if (val && !this.timer) {
        if (isSwitch) {
          if (this.switch) {
            this.triggerTimer();
          } else {
            this.clearTimer();
          }
        } else {
          this.triggerTimer();
        }
      } else {
        this.clearTimer();
      }
    }
    // 监听开关变化
  }, {
    key: "onSwitchChange",
    value: function onSwitchChange(val) {
      if (val) {
        this.triggerTimer();
      } else {
        this.clearTimer();
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.clearTimer();
    }
    // 清除定时器
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      if (this.timer) clearTimeout(this.timer);
    }
    // 触发倒计时函数
  }, {
    key: "triggerTimer",
    value: function triggerTimer() {
      var _this2 = this;
      this.timer = setTimeout(function () {
        _this2.timeDiff -= 1;
        if (_this2.timeDiff <= 0) {
          _this2.$emit('on-end');
        } else {
          _this2.$emit('on-countdown', _this2.timeDiff);
          _this2.triggerTimer();
        }
      }, this.computedStep);
    }
    // 格式化时间戳
  }, {
    key: "formatCountdown",
    value: function formatCountdown(timeDiff) {
      // 获取还剩多少小时
      // eslint-disable-next-line radix
      var hour = parseInt((timeDiff / 60 / 60).toString());
      // 获取还剩多少分钟
      var minute;
      if (this.format.includes('hh') || this.format.includes('HH')) {
        // eslint-disable-next-line radix
        minute = parseInt((timeDiff / 60 % 60).toString());
      } else {
        // eslint-disable-next-line radix
        minute = parseInt((timeDiff / 60).toString());
      }
      // 获取还剩多少秒
      var second;
      if (this.format.includes('mm') || this.format.includes('mm')) {
        second = timeDiff % 60;
      } else {
        second = timeDiff;
      }
      var result = this.format;
      result = result.replace(/(hh|HH)/g, this.paddingZero(hour));
      result = result.replace(/(mm|MM)/g, this.paddingZero(minute));
      result = result.replace(/(ss|ss)/g, this.paddingZero(second));
      return result;
    }
    // 补零
  }, {
    key: "paddingZero",
    value: function paddingZero(val) {
      if (val <= 0) {
        return '00';
      }
      if (val < 10) {
        return "0".concat(val);
      }
      return val.toString();
    }
    // 重新倒计时
  }, {
    key: "reCountdown",
    value: function reCountdown() {
      this.timeDiff = this.time;
    }
  }]);
}(Vue);
__decorate([Prop({
  default: 60,
  type: Number
})], Countdown.prototype, "time", void 0);
__decorate([Prop({
  default: 1,
  type: Number
})], Countdown.prototype, "step", void 0);
__decorate([Prop({
  default: null,
  type: Boolean
})], Countdown.prototype, "switch", void 0);
__decorate([Prop({
  type: String,
  default: 'hh:mm:ss'
})], Countdown.prototype, "format", void 0);
__decorate([Watch('time', {
  immediate: true
})], Countdown.prototype, "onTimeChange", null);
__decorate([Watch('switch')], Countdown.prototype, "onSwitchChange", null);
Countdown = __decorate([Component({
  name: 'Countdown'
})], Countdown);
export default Countdown;